export const MOUNT_POINT_SIDEBAR_TOP = 'bay-sidebar-top-slot';
export const MOUNT_POINT_SIDEBAR_BOTTOM = 'bay-sidebar-bottom-slot';

export const MOUNT_POINT_HEADER = 'bay-header-slot';

/**
 * 匹配到非叶子节点时，是否自动跳转到首个叶子节点
 */
export const AUTO_INDEX = true;

export const UNAUTH = 401;

/**
 * 多语言菜单的标识值
 */
export const DEFAULT_LANGUAGE_IDENTIFIER = 'i18n';

/**
 * 切换身份菜单的标识值
 */
export const SWITCH_IDENTITY_IDENTIFIER = 'switch-identity';
